export const loadFaceBookSDK = (params) => {
  const { cb, fcb, baseObj } = params || {};
  if (fcb) {
    fcb;
  }
  (function (d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
  let facebookScriptEl = document.querySelector(`#facebook-jssdk`);
  if (facebookScriptEl) {
    facebookScriptEl.addEventListener('load', () => {
      window.fbAsyncInit = function () {
        const facebook = baseObj.loginInfo.clientIds?.find((item) => item.loginType === 'FACEBOOK');
        FB.init({
          appId: facebook?.clientId,
          cookie: true,
          xfbml: true,
          version: 'v17.0',
        });
        FB.AppEvents.logPageView();
        cb && cb();
      };
    });
  }
};
const getFaceBook = (params) => {
  const { baseObj } = params;
  let timer;
  const facebook = baseObj.loginInfo.clientIds?.filter((item) => item.loginType === 'FACEBOOK');
  return new Promise((resolve) => {
    timer = setInterval(() => {
      if (facebook?.length !== 0) {
        loadFaceBookSDK({ baseObj });
        clearInterval(timer);
      } else {
        console.log('[dev]看看-getLoginMethod请求还没没没');
      }
    }, 1000);
    resolve('');
  });
};

export default getFaceBook;
